// extracted by mini-css-extract-plugin
export default {"cardContentContainer":"CardContent_cardContentContainer__2k0Ug"};